import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import classNames from 'classnames';
import 'react-datepicker/dist/react-datepicker.css';

const CustomInputStyles = {
  background: 'transparent',
  border: 0,
  borderBottom: '1px solid #ccc',
  borderRadius: 0,
  margin: 0,
  padding: 0
};

const CustomInput = props => {
  return (
    <button
      style={CustomInputStyles}
      onClick={props.onClick}
      className={classNames(props.className, 'custom-date-picker-input')}
    >
      {props.value && <i className="fa fa-calendar mr-2" aria-hidden="true" />}
      {props.value ? props.value : props.placeholder}
    </button>
  );
};

const CustomDatePicker = props => (
  <DatePicker
    {...props}
    customInput={<CustomInput {...props} />}
    dateFormat="ddd, MMM DD"
  />
);

CustomInput.propTypes = {
  onClick: PropTypes.func,
  value: PropTypes.string
};

CustomDatePicker.propTypes = {
  selected: PropTypes.object,
  placeholderText: PropTypes.string,
  onChange: PropTypes.func
};

export default CustomDatePicker;



// WEBPACK FOOTER //
// ./src/components/Social/CustomDatePicker.js